import GLightbox from 'glightbox';

class LightBox {
  constructor() {
    this.lightBoxesElements = document.querySelectorAll('[data-lightbox]');
    this.lightBoxes = {};
    this.init();
  }

  init() {
    if (this.lightBoxesElements) {
      this.lightBoxesElements.forEach((lightBox, index) => {
        // Get triggers and options
        const triggers = lightBox.querySelectorAll('[data-lightbox-trigger]');
        const optionsJSON = lightBox.dataset.lightbox;
        const optionsObject = JSON.parse(optionsJSON);

        // Lightbox key
        const lightBoxKey = `lightbox${index}`;

        // Build lightboxes
        this.buildLightboxes(lightBoxKey, optionsObject);

        // Attach events to each trigger
        triggers.forEach((trigger) => {
          trigger.addEventListener('click', () => {
            this.openLightbox(lightBoxKey, trigger.dataset.lightboxTrigger);
          });
        });
      });
    }
  }

  buildLightboxes(key, options) {
    this.lightBoxes[key] = GLightbox({
      elements: options,
      loop: true,
    });
  }

  openLightbox(key, imageID) {
    this.lightBoxes[key].openAt(imageID);
  }
}

document.addEventListener('DOMContentLoaded', () => new LightBox());
